import _toConsumableArray from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { MODULE_THEMES, TEMPLATE_THEMES } from '../Theme';
import { Box, Stack } from '../ui';
import { Module } from '../Module';
import { getAuthorDateString } from '../utils';
import { useDynamicNavBarColor } from './useDynamicNavBarColor';
import { jsx as _jsx } from "react/jsx-runtime";
export var ArticleTemplate = function ArticleTemplate(template) {
  var _template$theme = template.theme,
      theme = _template$theme === void 0 ? 'Dark' : _template$theme,
      headerModule = template.headerModule,
      introduction = template.introduction,
      article = template.article,
      video = template.video,
      _template$modules = template.modules,
      modules = _template$modules === void 0 ? [] : _template$modules,
      author = template.author,
      _template$releaseDate = template.releaseDate,
      releaseDate = _template$releaseDate === void 0 ? '' : _template$releaseDate,
      _template$initialDrop = template.initialDropcap,
      initialDropcap = _template$initialDrop === void 0 ? false : _template$initialDrop;
  var releaseDateParsed = new Date(releaseDate);
  var releaseDateFormatted = releaseDateParsed.toLocaleDateString(undefined, {
    month: 'long',
    year: 'numeric',
    day: 'numeric'
  });

  if (headerModule) {
    headerModule.releaseDate = releaseDateFormatted;
    headerModule.author = author;
  }

  var articleModule;

  if (article) {
    articleModule = {
      contentType: 'articleModule',
      introduction: introduction,
      author: author,
      releaseDate: releaseDateFormatted,
      body: article,
      initialDropcap: initialDropcap
    };
  }

  var tplTheme = TEMPLATE_THEMES[theme];

  var modTheme = function modTheme(mod) {
    return _objectSpread(_objectSpread({}, tplTheme), MODULE_THEMES[mod.themeName || ''] || {});
  };

  var isFullBleed = function isFullBleed(mod) {
    return ['videoModule', 'relatedStoriesList', 'articleHeaderModule', 'articleModule', 'featuredContentModule'].includes(mod.contentType);
  };

  var allModules = [headerModule, articleModule, video].concat(_toConsumableArray(modules || [])).filter(function (m) {
    return Boolean(m === null || m === void 0 ? void 0 : m.contentType);
  });
  useDynamicNavBarColor(allModules === null || allModules === void 0 ? void 0 : allModules[0], !!headerModule);
  var renderModule = React.useCallback(function (mod) {
    var modProps = _objectSpread({}, mod);

    modProps.authorDateString = getAuthorDateString(modProps.author, modProps.releaseDate);
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Module, _objectSpread(_objectSpread({}, modProps), {}, {
        shouldAnimate: false
      }))
    });
  }, []);
  return /*#__PURE__*/_jsx(Stack, {
    "data-testid": "landing-".concat(template.urlSlug || 'unknown'),
    children: allModules.map(function (mod, idx) {
      return /*#__PURE__*/_jsx(ThemeProvider, {
        theme: modTheme(mod),
        children: /*#__PURE__*/_jsx(Box, {
          noPadding: isFullBleed(mod),
          children: renderModule(mod)
        })
      }, "".concat(mod.id, "-").concat(idx));
    })
  });
};